import {Component} from '@angular/core';
// noinspection ES6PreferShortImport
import {WidgetInputDirective} from '../../directives';

@Component({
  selector: 'pt-widget-checkbox',
  template: `
    <div
      class='widget-border'
      data-testid="widget-checkbox"
      id='widget_{{initializationWidget.internalId}}'
      [ngSwitch]='initializationWidget?.version'>

      <pt-widget-checkbox-v0
        *ngSwitchCase='0'
        [lockAcquired]='lockAcquired'
        [initializationWidget]='initializationWidget'
        [status]='status'>
      </pt-widget-checkbox-v0>

      <pt-widget-version-missing
        *ngSwitchDefault
        [type]='initializationWidget?.type'
        [label]='initializationWidget?.label'
        [version]='initializationWidget?.version'>
      </pt-widget-version-missing>

    </div>
  `
})
export class WidgetCheckboxComponent extends WidgetInputDirective {
}
